import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useForm, ValidationMode } from 'react-hook-form'

import { designValidation } from '../helpers/validationSchema'

interface FormSubmitProviderProps {
  children: React.ReactNode
}

export const DesignFormProvider = ({ children }: FormSubmitProviderProps) => {
  const methods = useForm<DesignFormFields>({
    resolver: yupResolver(designValidation),
    defaultValues: {
      avatar: '',
      title: '',
      bio: '',
      themeId: 1,
      fontId: 1,
      color: '#5ac8fa',
    },
    mode: 'all' as keyof ValidationMode,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
